import React, { ReactElement } from 'react';
import { Strip } from '../../Models/Article';
import { DiscoverItem } from '../../Models/DiscoverItem';
import KodanshaWheelItem from '../KodanshaWheel/KodanshaWheelItem';
import './ProductSeriesGridStrip.scss';

interface ProductSeriesGridStripProps {
    strip: Strip;
}

interface Params {
    title: string;
    subTitle: string;
    items: DiscoverItem[];
}

export function ProductOrSeriesGridStrip({ strip: { params } }: ProductSeriesGridStripProps): ReactElement {
    const { title, subTitle, items } = params as Params;
    const hasProductItems = items.some(item => item.type === 'product');
    const hasSeriesItems = items.some(item => item.type === 'series');
    const isMixed = hasProductItems && hasSeriesItems;
    const ratio = isMixed ? 125 : undefined;
    return (
        <div className='ProductSeriesGridStrip'>
            <h3>{subTitle}</h3>
            <h2>{title}</h2>
            <div className='ProductSeriesGrid'>
                {items.slice(0, 10).map(item => (
                    <KodanshaWheelItem
                        key={item.content?.id}
                        product={item}
                        cta={item.cta}
                        title={item.content?.title ?? ''}
                        ratio={ratio}
                    />
                ))}
            </div>
        </div>
    );
}
